import React, { Component } from 'react';
import { Container } from 'reactstrap';

export interface InjectedDrawerProps {
  isOpen: boolean;
  toggleSideBox: () => void;
}
interface DrawerProps {
  children: (injectedProps: InjectedDrawerProps) => JSX.Element;
}

interface DrawerState {
  isOpen: boolean;
}

export class DrawerContainer extends Component<DrawerProps, DrawerState> {
  constructor(props: DrawerProps) {
    super(props);

    this.state = { isOpen: true };
  }

  public toggleSideBox = (forceState?: boolean) => {
    this.setState((state) => ({ isOpen: forceState || !state.isOpen }));
  };

  public render() {
    const { isOpen } = this.state;
    const { children } = this.props;

    return (
      <Container fluid>
        {children({
          isOpen,
          toggleSideBox: this.toggleSideBox,
        })}
      </Container>
    );
  }
}
